<template lang="pug">
  .component-client-smart-edit(v-if="$acl('edit-drivers')")
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit
  h3(v-else) Your account doesn't have permission to edit drivers.
</template>
<script type="text/babel">
  import SmartEdit from "components/structure/SmartEdit"
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";

  export default {
    name: "DriverSmartEdit",
    components: {SmartEdit},
    data() {
      return {
        options: {
          translations: {},
          types: {
            birthdate: 'date',
            gender: ['-', 'M', 'F'],
            title: ['-', 'Mr', 'Mrs', 'Ms', 'Miss']
          },
          disabled: [
            "id",
            "profile_picture",
            "status",
            "created",
          ],
          list: [
            "id",
            "client_id",
            "password",
            "uid",
            "status",
            "username",
            "client_name",
            "client_organization_name",
            "profile_picture",
            "created",
          ],
          listMode: 'blacklist',
        }
      }
    },
    created() {
    },
    methods: {
      updateFields(item) {
        this.item = item
      },
      edit() {
        KeplerBackofficeSdk.drivers.select(this.item.id).edit(this.item, (data) => {
          MaggieHelper.notification('edit-esit', 'Driver edited');
          location.reload()
        })
      }
    },
    props: [
      'item'
    ]
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverEdit.vue?4fc76456